import { render, staticRenderFns } from "./EditAccessPoint.vue?vue&type=template&id=534828bc"
import script from "./EditAccessPoint.vue?vue&type=script&lang=js"
export * from "./EditAccessPoint.vue?vue&type=script&lang=js"
import style0 from "./EditAccessPoint.vue?vue&type=style&index=0&id=534828bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports